import { getIn18Text } from '@/api/utils';
const SALES_PITCH_STAGE_CONFIG_LIST = [
    {
        id: 'START',
        name: getIn18Text('KAIFA'),
    },
    {
        id: 'INQUIRY',
        name: getIn18Text('XUNPAN'),
    },
    {
        id: 'QUOTATION',
        name: getIn18Text('BAOJIA'),
    },
    {
        id: 'SAMPLES',
        name: getIn18Text('YANGPIN'),
    },
    {
        id: 'ORDER',
        name: getIn18Text('DINGDAN'),
    },
    {
        id: 'MAINTENANCE',
        name: getIn18Text('RICHANGWEIHU'),
    },
];
const SALES_PITCH_STAGE_CONFIG_MAP = SALES_PITCH_STAGE_CONFIG_LIST.reduce((total, current) => {
    total[current.id] = current;
    return total;
}, {});
const ID_SEP = '@#@';
export const salesPitchHelper = {
    getSalesPitchStageConfList() {
        return SALES_PITCH_STAGE_CONFIG_LIST;
    },
    getSalesPitchStageConfMap() {
        return SALES_PITCH_STAGE_CONFIG_MAP;
    },
    genDefaultPitchDataMap() {
        return SALES_PITCH_STAGE_CONFIG_LIST.reduce((total, current) => {
            total[current.id] = [];
            return total;
        }, Object.create(null));
    },
    genSalesPitchCardId({ stageId, type, id }) {
        return `${stageId}${ID_SEP}${type}${ID_SEP}${id}`;
    },
    splitSalesPitchCardId(cardId) {
        const arr = cardId.split(ID_SEP);
        if (arr.length === 3) {
            return {
                stageId: arr[0],
                type: arr[1],
                id: +arr[2],
            };
        }
        return undefined;
    },
};
